import { createContext } from 'react';

export const FormSubmitContext = createContext({
  isSubmitEnabled: true,
  setIsSubmitEnabled: (isSubmitEnabled: boolean) => {},
});
